<template>
  <div class="temp2-disease-main">
      <div class="search-panel">
        <a-input v-model="queryParam.keyword" class="search-input" placeholder="请输入研究病种关键字进行查询" style="width: 400px;margin: 0 10px"></a-input>
        <a-button size="small" @click="loadDataByKeyword()">查询</a-button>
      </div>

      <div class="temp2-disease-title">
        选择研究病种
      </div>
      <div class="row row3">
        <div class="row3-item row-item-no" v-if="otherList.length == 0 && keywordList.length == 0">
          暂无病种
        </div>
        <template v-else>
          <div v-for="(item,index) in keywordList" :key="index" class="row3-item">
            <div class="row-item-btn" style="color:red">
              <a-icon type="plus" @click="addDisease(item)"/>
            </div>
            <div style="color:red">
              {{ item.name }}
            </div>
          </div>
          <div v-for="(item,index) in otherList" :key="index" class="row3-item">
            <div class="row-item-btn">
              <a-icon type="plus" @click="addDisease(item)"/>
            </div>
            <div>
              {{ item.name }}
            </div>
          </div>
        </template>
      </div>
      <br>
  </div>
</template>

<script>
import { getAction, postAction } from '@api/manage'
import Module from '@views/apppad/projectTemplate/projectTemplate2/Module.vue'

  export default {
    name: 'Disease',
    components: { Module },
    props: {
      project: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        queryParam: {
          keyword: null
        },
        keywordList: [],
        otherList: [],
        diseaseSelectedList: [],
        current: {}
      }
    },
    computed: {
      diseaseSelectedList1() {
        const result = []
        this.diseaseSelectedList.forEach(item => {
          if (item.main) {
            result.push(item)
          }
        })
        return result
      },
      diseaseSelectedList2() {
        const result = []
        this.diseaseSelectedList.forEach(item => {
          if (!item.main) {
            result.push(item)
          }
        })
        return result
      }
    },
    mounted() {
      
      // this.handleData()
      // this.loadData()
    },
    watch:{
      project:function(){
        this.queryParam = {
          projectName:this.project.projectName || this.project.name,
          keyword: ''
        }
        this.loadData();
        this.handleData();
      }
    },
    methods: {
      log(s, o) {
        console.log(s, JSON.parse(JSON.stringify(o)))
      },
      addDisease(disease) {
        this.$emit('submit',disease)
        // let has1 = false
        // let has2 = false
        // this.diseaseSelectedList.forEach(item => {
        //   if (disease.code === item.code) {
        //     has1 = true
        //   }
        //   if (item.main) {
        //     has2 = true
        //   }
        // })
        // if (has1) return this.$message.error('不能重复添加')
        // if (this.project.manyType === '0') { // 不是多病种
        //   this.diseaseSelectedList = [{
        //     main: true,
        //     ...disease
        //   }]
        //   this.submit()
        // } else {
        //   if (this.diseaseSelectedList.length === 2) {
        //     this.diseaseSelectedList.splice(1, 1, {
        //       main: false,
        //       ...disease
        //     })
        //     this.submit()
        //   } else {
        //     if (has2) {
        //       this.diseaseSelectedList.push({
        //         main: false,
        //         ...disease
        //       })
        //     } else {
        //       this.diseaseSelectedList.unshift({
        //         main: true,
        //         ...disease
        //       })
        //     }

        //     if (this.diseaseSelectedList.length === 2) {
        //       this.submit()
        //     }
        //   }
        // }
      },
      mainDisease(record) {
        this.$confirm({
          title: '设为主病种',
          content: (<div>
            <p>您确定要设置这个病种为主病种吗？</p>
          </div>),
          centered: false,
          onOk: () => {
            this.diseaseSelectedList.forEach(item => {
              item.main = false
            })
            record.main = true
            if (this.diseaseSelectedList === 2) {
              let [a, b] = this.diseaseSelectedList
              this.diseaseSelectedList = [b, a]
            }
            this.submit()
          }
        })
      },
      deleteDisease(index) {
        this.$confirm({
          title: '删除病种',
          content: (<div>
            <p>您确定要删除这个病种吗？</p>
          </div>),
          centered: false,
          onOk: () => {
            this.diseaseSelectedList.splice(index, 1)
          }
        })
      },
      handleData() {
        this.diseaseSelectedList = JSON.parse(this.project.diseaseJson||'[]')
      },
      loadDataByKeyword() {
        // this.queryParam.projectName = ''
        this.loadData()
      },
      loadData() {
        const deptCodeList = []
        JSON.parse(this.project.deptJson||'[]').forEach(dept => {
          deptCodeList.push(dept.code)
        })
        this.deptCodeList = deptCodeList

        const queryParam = Object.assign({}, this.queryParam)
        queryParam.deptCodes = this.deptCodeList.join(',')
        getAction('/projectconfigview/configDisease/list', queryParam).then(res => {
          if (res.success) {
            this.keywordList = res.result.keywordList
            this.otherList = res.result.otherList
            if (this.keywordList.length === 0 && this.otherList.length === 0) {
              this.$message.warn('请输入合适的关键字')
            }
          }
        })
      },
      submit() {
        if (this.diseaseSelectedList.length === 0) {
          return this.$message.error('请选择病种')
        }
        postAction('/projectconfigview/configProject/saveDisease', { id: this.project.id, diseaseJson: JSON.stringify(this.diseaseSelectedList) }).then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.$emit('submit')
          } else {
            this.$message.error(res.message)
          }
        })
      },
    }
  }
</script>

<style scoped lang="less">
.temp2-disease-main{
  .search-panel{
    span{
      color:white;
    }
    .search-input{
      width: 400px;
      margin: 0 10px;
      color: white;
      border: 1px solid rgba(0, 0, 0, 0.2);
      background: rgba(255, 255, 255, 0.15);
    }
    margin-bottom: 20px;
  }
  .temp2-disease-title{
    font-size: 18px;
    color: white;
  }
  .temp2-disease-title2{
    font-size: 14px;
    color: white;
  }
  .row1{
    width: 100%;
    overflow-x: auto;
    white-space: nowrap;
    .row1-item{
      display: inline-table;
      width: 160px;
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
      position: relative;
      font-size: 18px;
      color: white;
      background-color: #376EFF;
    }
    .row2-item{
      width: 140px !important;

    }

  }
  .row-item-btn{
    position: absolute;
    right: 5px;
    top: 0px;
  }
  .row-item-btn2{
    position: absolute;
    left: 5px;
    top: 0px;
  }
  .row2{
    .row2-item{
      display: inline-table;
      width: 140px;
      text-align: center;
      padding-top: 16px;
      padding-bottom: 16px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border-radius: 10px;
      position: relative;
      font-size: 18px;
      color:white;
      background-color: #284895;
    }

  }
  .row3{
    display: flex;
    flex-wrap: wrap;
    .row3-item{
      width: 100px;
      text-align: center;
      padding-top: 10px;
      padding-bottom: 10px;
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 10px;
      border: 1px solid rgba(0,0,0,0.2);
      border-radius: 10px;
      position: relative;
      font-size: 14px;
      color: rgba(255,255,255,0.7);
      background: rgba(255,255,255,0.07);
    }

  }
  .row-item-no{
    border: 1px dashed rgba(0,0,0,0.2) !important;
  }
}

.gauge {
  padding: 15px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);

  .title1 {
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      color: white;
      margin: 0 10px 0 0;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 12px;

    /deep/ .ant-checkbox-wrapper {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #376eff;
      border-color: #376eff;
    }

    .item {
      position: relative;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;
      padding: 10px 0;

      /deep/ .ant-checkbox+span {
        display: block;
      }

      em {
        font-style: normal;
        color: white;
      }
    }

    .info {
      margin-left: 35px;

      .line1 {
        strong {
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
        }

        span {
          display: inline-block;
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          padding: 3px 5px;
          margin-left: 5px;
          background: #343546;
          border-radius: 4px;
        }
      }

      .line2 {
        padding: 3px 0;

        dl {
          display: flex;
          margin: 0;
          align-items: center;
        }

        dt {
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.4);
          line-height: 14px;
          word-break: keep-all
        }

        dd {
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 16px;
          margin: 0 0 0 10px;
        }

        /deep/ .ant-rate {
          font-size: 12px;
        }
      }
    }
  }
}
</style>
